import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import getOfficesResponse from "@/types/responses/getOffices"
import { Ref, onMounted, ref, computed } from 'vue';
import Api from "@/services/api/ApiServiceFabrick";
import i18n from '@/lang/i18n';

type officeType = {
  id: number | null,
  type: string,
  name: string,
  departments: any[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationAutoComplate',
  props: {
    modelValue: {},
    selectedOfficeableType: {},
    errorMessages: {},
    readonly: { type: Boolean, default: false },
    clearable: { type: Boolean, default: true }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props

const items: Ref<getOfficesResponse[]> = ref([])

onMounted(() => {
  Api().getOffices().then((data: getOfficesResponse[]) => {
    data.forEach((office: getOfficesResponse) => {
      items.value.push({
        id: office.id,
        type: office.type.split('\\')[2],
        name: office.company_name ?? office.operation_office_name,
        departments: office.departments ?? []
      })
    })
  })
})

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const selectableItems = computed(() => {
  if (!props.selectedOfficeableType.type) return items.value
  return items.value.filter((item) => {
    return item.type === props.selectedOfficeableType.type
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithSingleSelectedItem, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    label: _unref(i18n).global.t('pages.common.filter.organization'),
    itemName: "name",
    items: selectableItems.value,
    selectFirstIfOnlyOne: true,
    clearable: __props.clearable,
    readonly: __props.readonly,
    "error-messages": __props.errorMessages
  }, null, 8, ["modelValue", "label", "items", "clearable", "readonly", "error-messages"]))
}
}

})